import { BadgeServiceService } from './services/badgeService/badge-service.service';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  title = 'PABadgesNetwork';
  badgeNumber: number = 0;
  hideImg: boolean = false;

  constructor(private _router: Router, private _badgeService:BadgeServiceService) {
    this._badgeService.usersObservable.subscribe((value) => {
      this.badgeNumber = value.length;
    });
  }

  ngOnInit(): void {
    console.log(localStorage.getItem('paBadges'));
    console.log(localStorage.getItem('paToken'));
    console.log(localStorage.getItem('paPayment'));
    console.log(localStorage.getItem('paOutcomeReference'));
    this.badgeNumber = this._badgeService.users.length;
    this._router.navigate(['user-details-forum']);
    this.setWindow();
  }

  goHome(): void {
    this._router.navigate(['user-details-forum']);
  }

  onResize(event: any): void {
    this.setWindow();
  }

  setWindow(): void {
    if (window.innerWidth <= 600) {
      this.hideImg = true;
    } else {
      this.hideImg = false;
    }
  }

  changeMe():void {
    //window.open("http://localhost:4200", "_blank");
  }
}
